<template>
  <DialogModal :is-destructive-alert="false" :hideSecondaryButton="true" @primary="$emit('ok')">
    <span slot="header" v-localize="HEADER_TEXT_KEY" />
    <span slot="body" v-localize="BODY_TEXT_KEY" />
    <span slot="primary-button-text" v-localize="PRIMARY_BUTTON_TEXT_KEY" />
  </DialogModal>
</template>

<script>
import DialogModal from '@/components/AvatarBuilderUI/Dialogs/DialogModal.vue';
import { LocalizationDirective } from '@/directives/LocalizationDirective';

export default {
  name: 'ItemDeprecatedDialog',
  components: {
    DialogModal,
  },
  created: function() {
    this.HEADER_TEXT_KEY = 'ItemDeprecatedDialogTitle';
    this.BODY_TEXT_KEY = 'ItemDeprecatedDialogMessage';
    this.PRIMARY_BUTTON_TEXT_KEY = 'Okay';
  },
  directives: {
    LocalizationDirective,
  },
};
</script>
